import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M18 8.5C18 8.91667 18.1458 9.27083 18.4375 9.5625C18.7292 9.85417 19.0833 10 19.5 10H28V30.5C28 30.9167 27.8542 31.2708 27.5625 31.5625C27.2708 31.8542 26.9167 32 26.5 32H5.5C5.08333 32 4.72917 31.8542 4.4375 31.5625C4.14583 31.2708 4 30.9167 4 30.5V1.5C4 1.08333 4.14583 0.729167 4.4375 0.4375C4.72917 0.145833 5.08333 0 5.5 0H18V8.5ZM28 7.625V8H20V0H20.375C20.7917 0 21.1458 0.145833 21.4375 0.4375L27.5625 6.5625C27.8542 6.85417 28 7.20833 28 7.625Z'],
  name: 'uiFileSolid',
  oldName: 'fasFile'
} as IconDefinition
